
export default function FreeIcon({...props}) {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox='0 0 32 32'
            {...props}
        >
            <path
            fill="#1A1B41"
            fillRule="evenodd"
            style={{
                lineHeight: "normal",
                textIndent: 0,
                textAlign: "start",
                textDecorationLine: "none",
                textDecorationStyle: "solid",
                textDecorationColor: "#000",
                textTransform: "none",
                msBlockProgression: "tb",
                isolation: "auto",
                mixBlendMode: "normal",
            }}
            d="M23.637 737.484a3.498 3.498 0 0 1 .23-2.27.5.5 0 0 1 .908.423 2.494 2.494 0 0 0 .702 2.998 2.493 2.493 0 0 0 3.078.04 2.495 2.495 0 0 0 .783-2.978 2.495 2.495 0 0 0-2.703-1.476.5.5 0 1 1-.162-.987 3.502 3.502 0 0 1 3.783 2.067 3.506 3.506 0 0 1-1.096 4.172 3.502 3.502 0 0 1-4.31-.059 3.492 3.492 0 0 1-1.213-1.93z"
            color="#1A1B41"
            fontFamily="sans-serif"
            fontWeight={400}
            overflow="visible"
            transform="translate(-3.549 -718.188)"
            />
            <path
            fill="#1A1B41"
            fillRule="evenodd"
            style={{
                lineHeight: "normal",
                textIndent: 0,
                textAlign: "start",
                textDecorationLine: "none",
                textDecorationStyle: "solid",
                textDecorationColor: "#1A1B41",
                textTransform: "none",
                msBlockProgression: "tb",
                isolation: "auto",
                mixBlendMode: "normal",
            }}
            d="M7.66 723.688a.5.5 0 0 0-.463.369l-1.34 5a.5.5 0 1 0 .965.26l1.211-4.518 11.104 2.976 7.406 1.983.988 6.879a.5.5 0 1 0 .99-.143l-1.037-7.205a.5.5 0 0 0-.365-.412l-7.724-2.068-11.586-3.106a.5.5 0 0 0-.149-.015z"
            color="#000"
            fontFamily="sans-serif"
            fontWeight={400}
            overflow="visible"
            transform="translate(-3.549 -718.188)"
            />
            <path
            fill="#1A1B41"
            fillRule="evenodd"
            style={{
                lineHeight: "normal",
                textIndent: 0,
                textAlign: "start",
                textDecorationLine: "none",
                textDecorationStyle: "solid",
                textDecorationColor: "#000",
                textTransform: "none",
                msBlockProgression: "tb",
                isolation: "auto",
                mixBlendMode: "normal",
            }}
            d="M4.049 729.188a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5H24.04a.5.5 0 0 0 .434-.252l4-7a.5.5 0 0 0 0-.497l-4-7a.5.5 0 0 0-.434-.251H4.049zm.5 1h19.203l3.713 6.5-3.713 6.5H4.549v-13z"
            color="#1A1B41"
            fontFamily="sans-serif"
            fontWeight={400}
            overflow="visible"
            transform="translate(-3.549 -718.188)"
            />
            <path
            fill="#1A1B41"
            fillRule="evenodd"
            style={{
                lineHeight: "normal",
                textIndent: 0,
                textAlign: "start",
                textDecorationLine: "none",
                textDecorationStyle: "solid",
                textDecorationColor: "#000",
                textTransform: "none",
                msBlockProgression: "tb",
                isolation: "auto",
                mixBlendMode: "normal",
            }}
            d="M25.541 736.688c0-1.097-.9-1.997-1.996-1.997-1.097 0-1.996.9-1.996 1.996 0 1.097.9 1.997 1.996 1.997 1.097 0 1.996-.9 1.996-1.996zm-1 0c0 .556-.44.996-.996.996a.988.988 0 0 1-.996-.996c0-.557.44-.997.996-.997s.996.44.996.996zm5-.5v1h2.5v-1h-2.5z"
            color="#1A1B41"
            fontFamily="sans-serif"
            fontWeight={400}
            overflow="visible"
            transform="translate(-3.549 -718.188)"
            />
            <path
            fill="#1A1B41"
            fillRule="evenodd"
            style={{
                lineHeight: "normal",
                textIndent: 0,
                textAlign: "start",
                textDecorationLine: "none",
                textDecorationStyle: "solid",
                textDecorationColor: "#000",
                textTransform: "none",
                msBlockProgression: "tb",
                isolation: "auto",
                mixBlendMode: "normal",
            }}
            d="M31.541 736.68a.5.5 0 0 1 .508-.492 3.5 3.5 0 0 1 3.5 3.5.5.5 0 1 1-1 0 2.5 2.5 0 0 0-2.5-2.5.5.5 0 0 1-.508-.508z"
            color="#1A1B41"
            fontFamily="sans-serif"
            fontWeight={400}
            overflow="visible"
            transform="translate(-3.549 -718.188)"
            />
            <g
            style={{
                lineHeight: "125%",
            }}
            >
                
            <path
                d="M7.56 734.387h1.665v-.92H6.55v6.44H7.56v-2.659h1.307v-.92H7.56v-1.94zm5.296 5.52c-.1-.24-.11-.47-.11-.783v-.993c0-.671-.166-1.159-.671-1.37.45-.212.662-.644.662-1.307v-.506c0-.993-.45-1.48-1.5-1.48H9.711v6.438h1.011v-2.621h.35c.46 0 .662.22.662.818v1.012c0 .525.037.626.092.791h1.03zm-1.646-5.52c.359 0 .515.203.515.663v.634c0 .515-.23.681-.607.681h-.396v-1.978h.488zm3.213 0h1.748v-.92h-2.76v6.44h2.76v-.92h-1.748V737.1h1.39v-.92h-1.39v-1.794zm3.378 0h1.748v-.92h-2.76v6.44h2.76v-.92H17.8V737.1h1.389v-.92H17.8v-1.794z"
                fontFamily="Bebas Neue"
                fontSize={9.198}
                fontWeight={700}
                style={{
                    //@ts-ignore
                    InkscapeFontSpecification: "'Bebas Neue Bold'",
                }}
                fill="#1A1B41"
                letterSpacing={0}
                wordSpacing={0}
                transform="translate(-3.549 -718.188)"
            />
            </g>
        </svg>
    )
}
